<template>
  <!-- Main Wrapper -->
  <div class="main-wrapper">
    <layouts></layouts>
    <sidebar></sidebar>
    <div class="page-wrapper">
      <div class="content">
        <pageaddheader :title="title" :title1="title1" :items="items" />

        <!-- /product list -->
        <div class="card">
          <div class="card-body">
            <div class="table-top">
              <div class="search-set">
                <div class="search-path">
                  <a
                    class="btn btn-filter"
                    id="filter_search"
                    v-on:click="filter = !filter; this.search=''"
                    :class="{ setclose: filter }"
                  >
                    <img src="../../../assets/img/icons/filter.svg" alt="img" />
                    <span
                      ><img src="../../../assets/img/icons/closes.svg" alt="img"
                    /></span>
                  </a>
                </div>
                <div class="search-input">
                  <a class="btn btn-searchset"
                    ><img src="../../../assets/img/icons/search-white.svg" alt="img"
                  /></a>
                  <div id="DataTables_Table_0_filter" class="dataTables_filter">
                    <label>
                      <input
                        type="search"
                        v-model="search"
                        class="form-control form-control-sm"
                        placeholder="Search..."
                        aria-controls="DataTables_Table_0"
                      />
                    </label>
                  </div>
                </div>
              </div>
              <!-- <div class="wordset">
                <ul>
                  <li>
                    <a data-bs-toggle="tooltip" data-bs-placement="top" title="pdf"
                      ><img src="../../../assets/img/icons/pdf.svg" alt="img"
                    /></a>
                  </li>
                  <li>
                    <a data-bs-toggle="tooltip" data-bs-placement="top" title="excel"
                      ><img src="../../../assets/img/icons/excel.svg" alt="img"
                    /></a>
                  </li>
                  <li>
                    <a data-bs-toggle="tooltip" data-bs-placement="top" title="print"
                      ><img src="../../../assets/img/icons/printer.svg" alt="img"
                    /></a>
                  </li>
                </ul>
              </div> -->
            </div>
            <!-- /Filter -->
            <!-- <div
              class="card"
              id="filter_inputs"
              :style="{
                display: filter ? 'block' : 'none',
              }"
            >
              <div class="card-body pb-0">
                <div class="row">
                  <div class="col-lg-2 col-sm-6 col-12">
                    <div class="form-group">
                      <input type="text" placeholder="Enter Supplier Code" />
                    </div>
                  </div>
                  <div class="col-lg-2 col-sm-6 col-12">
                    <div class="form-group">
                      <input type="text" placeholder="Enter Supplier" />
                    </div>
                  </div>
                  <div class="col-lg-2 col-sm-6 col-12">
                    <div class="form-group">
                      <input type="text" placeholder="Enter Phone" />
                    </div>
                  </div>
                  <div class="col-lg-2 col-sm-6 col-12">
                    <div class="form-group">
                      <input type="text" placeholder="Enter Email" />
                    </div>
                  </div>
                  <div class="col-lg-1 col-sm-6 col-12 ms-auto">
                    <div class="form-group">
                      <a class="btn btn-filters ms-auto"
                        ><img src="../../../assets/img/icons/search-whites.svg" alt="img"
                      /></a>
                    </div>
                  </div>
                </div>
              </div>
            </div> -->
            <!-- /Filter -->
            <div class="table-responsive">
              <a-table
                :columns="columns"
                :data-source="filteredItems"
              >
                <template #bodyCell="{ column, record }">
                  <template v-if="column.key === 'vendorid'">
                    <div class="productimgname">
                     
                      <router-link :to="{ path: '/supplier-details', query: { id: record.vendorid } }" title="View details">{{ record.vendorname }}</router-link>
                    </div></template
                  >

                  <template v-else-if="column.key === 'action'">
                    <router-link class="me-3" :to="{ path: '/supplier-details', query: { id: record.vendorid } }" title="View details">
                      <img src="../../../assets/img/icons/eye.svg" alt="View" />
                    </router-link>
                    <template v-if="canEditSuppliers || canDeleteSuppliers">
                    <a v-if="canEditSuppliers" class="me-3" @click="editvendor(record)" href="javascript:void(0);">
                      <img src="../../../assets/img/icons/edit.svg" alt="img" />
                    </a>  
                    <a
                      v-if="canDeleteSuppliers"
                      class="me-3 confirm-text"
                      href="javascript:void(0);"
                      @click="showAlert(record.vendorid)"
                    >
                      <img src="../../../assets/img/icons/delete.svg" alt="img" />
                    </a>
                    </template>
                  </template>
                </template>
              </a-table>
            </div>
          </div>
        </div>
        <!-- /product list -->
      </div>
    </div>
  </div>
  <supplierlistmodal></supplierlistmodal>
</template>
<script>
import axios from "axios";
axios.defaults.baseURL = process.env.VUE_APP_API_URL;
axios.defaults.headers.post['Content-Type'] ='application/json;charset=utf-8';
axios.defaults.headers.common['api-key'] = process.env.VUE_APP_API_KEY;
const columns = [
  {
    sorter: true,
  },
  {
    title: "Supplier Name",
    dataIndex: "vendorname",
    key: "vendorid",
    sorter: {
      compare: (a, b) => {
        a = a.vendorname.toLowerCase();
        b = b.vendorname.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
   title: "Contact person",
    dataIndex: "contactperson",
    sorter: {
      compare: (a, b) => {
        a = a.contactperson.toLowerCase();
        b = b.contactperson.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "Address",
    dataIndex: "address",
    sorter: {
      compare: (a, b) => {
        a = a.address.toLowerCase();
        b = b.address.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "Email",
    dataIndex: "email",
    sorter: {
      compare: (a, b) => {
        a = a.email.toLowerCase();
        b = b.email.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "Phone",
    dataIndex: "phone",
    sorter: {
      compare: (a, b) => {
        a = a.phone;
        b = b.phone;
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "GSTIN",
    dataIndex: "gstin",
    sorter: {
      compare: (a, b) => {
        a = (a.gstin || "").toLowerCase();
        b = (b.gstin || "").toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "Action",
    key: "action",
    sorter: true,
  },
];
const data = [
  {
    id: 1,
    SupplierName: "Apex Computers",
    code: "201",
    Phone: "+12163547758",
    email: "thomas@example.com",
    Country: "China",
  },
];
export default {
  data() {
    return {
      filter: false,
      search: '',
      title: "Suppliers List",
      title1: "Manage your Supplier",
      data,
      columns,
    };
  },
  computed: {
    canAddSuppliers() {
      return this.$store.getters.hasPermission('supplier.add');
    },
    canEditSuppliers() {
      return this.$store.getters.hasPermission('supplier.edit');
    },
    canDeleteSuppliers() {
      return this.$store.getters.hasPermission('supplier.delete');
    },
    items() {
      return this.canAddSuppliers
        ? [{ text: "Add Supplier", addname: "/addsupplier" }]
        : [];
    },
    filteredItems() {
      return this.data?this.data.filter(item => {
        return !this.search || 
                item['vendorname'].toString().toLowerCase().includes(this.search.toLowerCase());
      }):null;
    },
  },
  methods: {
    handleKeydown(event) {
      if (
        this.canAddSuppliers &&
        this.$route.path === '/supplierlist' &&
        event.ctrlKey &&
        (event.key === 'm' || event.key === 'M')
      ) {
        event.preventDefault(); 
        
        this.$router.push('/addsupplier');
      }
    },
    searching() {
      if (this.search) this.filter = true;
    },
    showAlert(id) {
      if (!this.canDeleteSuppliers) {
        return;
      }
      // Use sweetalert2
      Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        showCancelButton: true,
        confirmButtonColor: "#FF9F43",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
      }).then((result) => {
        if (result.isConfirmed) {
          axios
          .delete('/v1/vendors/'+id)
          .then(response => {
            //this.res = "Status " + response.status + ". Category created";
            Swal.fire("Deleted!", "Supplier has been deleted.");
            var index = this.data.findIndex(function(o){
              return o.vendorid === id;
            })
            if (index !== -1) this.data.splice(index, 1);
          })
          .catch(error => {
            console.log(error)
            Swal.fire(error.response.data.detail);
          });
          
        }
      });
    },
    editvendor(vendor) {
      if (!this.canEditSuppliers) {
        return;
      }
      this.$router.push({ path: '/editsupplier', query: { id: vendor.vendorid } });
    },
    async getvendor() {
      axios
      .get('/v1/vendors')
      .then(response => {
        this.data = response.data
      })
      .catch(error => {
        console.log(error)
        this.errored = true
      });
    }
  },
  mounted() {
    document.addEventListener('keydown', this.handleKeydown);
  },
  beforeDestroy() {
    document.removeEventListener('keydown', this.handleKeydown);
  },
  beforeMount() {
    this.getvendor();
  },
  name: "supplierlist",
};
</script>
          
